import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import CategoryPage from '../views/CategoryPage.vue'
import ProductPage from '../views/ProductPage.vue'
import CheckoutPage from '../views/CheckoutPage.vue'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    { path: '/', name: 'home', component: HomePage },
    { path: '/shop', name: 'shop', component: CategoryPage },
    { path: '/collections/:handle', name: 'collection', component: CategoryPage, props: true },
    { path: '/products/:handle', name: 'product', component: ProductPage, props: true },
    { path: '/checkout', name: 'checkout', component: CheckoutPage },
  ],
  scrollBehavior(to) {
    // Leave room for the sticky header when jumping to an in-page section.
    if (to.hash) return { el: to.hash, top: 100, behavior: 'smooth' }
    return { top: 0 }
  },
})

export default router
